// IE 2026 10 13 / ODOO-5800 (Igor: «я ожидаю, что смогу менять такие динамические списки с возникновением кнопки сохранить над ними; и ожидаю,
// что записи в этот динамический список будут попадать при открытии пользователем вкладки с ними (а не при открытии виджета записи)»).
// Ленивая вкладка (AttrTab: lazyMethod / lazyBinding) кладёт строки в record._doc.<binding>; _doc бэку не уходит (record_sendToBackend_exclude),
// поэтому правки такого грида раньше никуда не попадали. Вкладка (или сам грид) объявляет saveMethod — над гридом с правками появляется
// полоса «Save (N)» / «Discard»; Save зовёт executeWidgetMethod(saveMethod, params = gridSave_payload(...)), ответ (строки) заменяет _doc.<binding>.
// Отслеживание правок — по ТОЖДЕСТВУ строк последней загрузки (base) и их чистому снимку (служебные ключи _* / $* не в счёт):
// строка base с другим содержимым — changed, строка не из base — added, строка base, которой нет в гриде, — deleted.
// Флаг fe.ux.gridSaveBar (дефолт ВКЛ); выкл — полосы нет, гарда нет, как было. Юнит tests/unit/gridSaveBar.test.mjs
export const GRID_SAVE_BAR_FLAG = 'fe.ux.gridSaveBar'   // IE 2026 10 13 / ODOO-5800

export function gridSaveBar_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(GRID_SAVE_BAR_FLAG, true) !== false : true } catch (e) { return true }
}

// метод сохранения грида: свой attr.saveMethod; иначе saveMethod родительской вкладки, если её ленивая привязка — привязка этого грида
// (у вкладки без lazyBinding — её единственного/любого грида)
export function gridSave_method(attr, parentTab) {   // IE 2026 10 13 / ODOO-5800
    const own = attr && typeof attr.saveMethod === 'string' ? attr.saveMethod.trim() : ''
    if (own) return own
    const tm = parentTab && typeof parentTab.saveMethod === 'string' ? parentTab.saveMethod.trim() : ''
    if (!tm) return ''
    if (parentTab.lazyBinding && attr && parentTab.lazyBinding !== attr.binding) return ''
    return tm
}

const _service = (k) => typeof k === 'string' && (k.startsWith('_') || k.startsWith('$'))

// глубокая копия значения без служебных ключей (_meta, _fe, $item …) — то, что уходит бэку и с чем сравнивается снимок
export function gridSave_clean(v) {   // IE 2026 10 13 / ODOO-5800
    if (Array.isArray(v)) return v.map(gridSave_clean)
    if (v && typeof v === 'object') {
        if (v instanceof Date) return v.toISOString()
        const out = {}
        for (const k of Object.keys(v)) {
            if (_service(k)) continue
            const x = v[k]
            if (typeof x === 'function' || x === undefined) continue
            out[k] = gridSave_clean(x)
        }
        return out
    }
    return v
}

const _json = (row) => { try { return JSON.stringify(gridSave_clean(row)) } catch (e) { return '' } }
const _ident = (x) => x

// снимок последней загрузки: объекты строк (raw — снятие реактивного прокси) и их чистый JSON
export function gridSave_baseline(rows, raw = _ident) {   // IE 2026 10 13 / ODOO-5800
    const list = Array.isArray(rows) ? rows : []
    return { src: list, objs: list.map((r) => raw(r)), json: list.map(_json) }
}

// строки снимка заново (Discard): новые объекты из чистого JSON
export function gridSave_restoreRows(base) {   // IE 2026 10 13 / ODOO-5800
    return (base?.json || []).map((s) => { try { return JSON.parse(s) } catch (e) { return {} } })
}

// ключ строки для deleted: id (или keyField); нет ключа — сама чистая строка
export function gridSave_key(row, keyField = 'id') {   // IE 2026 10 13 / ODOO-5800
    if (row && typeof row === 'object' && row[keyField] !== undefined && row[keyField] !== null && row[keyField] !== '') return row[keyField]
    return null
}

// разница текущих строк грида со снимком: { changed: [строки], added: [строки], deleted: [ключи | чистые строки без ключа], count }
export function gridSave_diff(rows, base, opts = {}) {   // IE 2026 10 13 / ODOO-5800
    const raw = typeof opts.raw === 'function' ? opts.raw : _ident
    const keyField = opts.keyField || 'id'
    const list = Array.isArray(rows) ? rows : []
    const objs = base?.objs || [], json = base?.json || []
    const idx = new Map()
    objs.forEach((o, i) => { if (o && typeof o === 'object' && !idx.has(o)) idx.set(o, i) })
    const seen = new Set(), changed = [], added = [], deleted = []
    for (const row of list) {
        const i = row && typeof row === 'object' ? idx.get(raw(row)) : undefined
        if (i === undefined || seen.has(i)) { added.push(row); continue }
        seen.add(i)
        if (_json(row) !== json[i]) changed.push(row)
    }
    for (let i = 0; i < objs.length; i++) {
        if (seen.has(i)) continue
        let snap = null
        try { snap = JSON.parse(json[i]) } catch (e) { snap = null }
        const k = gridSave_key(snap, keyField)
        deleted.push(k !== null ? k : snap)
    }
    return { changed, added, deleted, count: changed.length + added.length + deleted.length }
}

// params вызова saveMethod: { binding, changed: [чистые строки], added: [чистые строки], deleted: [ключи] }
export function gridSave_payload(binding, diff) {   // IE 2026 10 13 / ODOO-5800
    return {
        binding: binding || '',
        changed: (diff?.changed || []).map(gridSave_clean),
        added: (diff?.added || []).map(gridSave_clean),
        deleted: (diff?.deleted || []).map((k) => (k && typeof k === 'object' ? gridSave_clean(k) : k)),
    }
}

// показывать ли полосу над гридом: флаг ВКЛ, у грида есть saveMethod, есть правки (или идёт сохранение)
export function gridSave_barVisible({ flagOn = true, saveMethod = '', count = 0, saving = false } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (flagOn === false || !saveMethod) return false
    return count > 0 || saving === true
}

// ответ бэка — успех? (нет ответа, notification error / critical, error — неуспех: полоса остаётся)
export function gridSave_replyOk(answer) {   // IE 2026 10 13 / ODOO-5800
    if (!answer || typeof answer !== 'object') return false
    if (answer.error) return false
    const st = answer.notification?.status
    return !(st === 'error' || st === 'critical')
}

// строки из ответа: answer.rows; либо updateDoc с updates [{ binding: 'record.<binding>' | '<binding>', value }]. Нет — null
export function gridSave_replyRows(answer, binding) {   // IE 2026 10 13 / ODOO-5800
    if (!answer || typeof answer !== 'object') return null
    if (Array.isArray(answer.rows)) return answer.rows
    for (const a of [answer, ...(Array.isArray(answer.actions_after) ? answer.actions_after : [])]) {
        for (const u of (a && Array.isArray(a.updates) ? a.updates : [])) {
            if (u && (u.binding === `record.${binding}` || u.binding === binding) && Array.isArray(u.value)) return u.value
        }
    }
    return null
}

// IE 2026 10 13 / ODOO-5800 (бот dev02: бэк отклонил Save ответом БЕЗ строк и БЕЗ notification — только responsible_register.errors; фронт считал это успехом:
// полоса гасла, тоста нет, несохранённый текст оставался в гриде): первая строка ошибки в ответе — любой ключ, оканчивающийся на errors / error (строка или массив строк)
export function gridSave_firstError(answer) {
    const seen = new Set()
    const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : '')
    const walk = (node, depth) => {
        if (!node || typeof node !== 'object' || depth > 6 || seen.has(node) || seen.size > 2000) return ''
        seen.add(node)
        if (Array.isArray(node)) {
            for (const x of node) { const r = walk(x, depth + 1); if (r) return r }
            return ''
        }
        for (const k of Object.keys(node)) {
            if (!/errors?$/i.test(k)) continue
            const v = node[k]
            const s = str(v)
            if (s) return s
            if (Array.isArray(v)) {
                for (const x of v) { const sx = str(x) || (x && typeof x === 'object' ? str(x.text) || str(x.message) || str(x.error) : ''); if (sx) return sx }
            } else if (v && typeof v === 'object') { const r = walk(v, depth + 1); if (r) return r }
        }
        for (const k of Object.keys(node)) {
            const v = node[k]
            if (v && typeof v === 'object') { const r = walk(v, depth + 1); if (r) return r }
        }
        return ''
    }
    return walk(answer, 0)
}

// решение по ответу Save: ok — ТОЛЬКО если в ответе свежие строки грида (updateDoc record.<binding> | rows); иначе неуспех: полоса и правки остаются.
// { ok, rows, text, shown, hint }: text — текст ошибки для тоста (notification ответа, иначе «Save failed: <первая ошибка | no rows returned>»);
// shown — тост уже показан (notification error / critical с текстом показал TERMINAL; пустой ответ — отказ роли / исключение сборки), второй не нужен; hint — строка hint ответа при успехе (info-тост)
export function gridSave_outcome(answer, binding) {
    if (!answer || typeof answer !== 'object') return { ok: false, rows: null, text: 'Save failed: no rows returned', shown: true, hint: '' }   // нет ответа вовсе (роль «только чтение», исключение сборки) — свой тост уже показан
    const ntf = answer.notification && typeof answer.notification === 'object' ? answer.notification : null
    const ntfText = ntf && typeof ntf.text === 'string' ? ntf.text.trim() : ''
    const rows = gridSave_replyRows(answer, binding)
    if (gridSave_replyOk(answer) && Array.isArray(rows)) {
        return { ok: true, rows, text: '', shown: false, hint: typeof answer.hint === 'string' ? answer.hint.trim() : '' }
    }
    const isErr = !!ntf && (ntf.status === 'error' || ntf.status === 'critical')
    if (ntfText) return { ok: false, rows: null, text: ntfText, shown: isErr, hint: '' }
    const err = (typeof answer.error === 'string' && answer.error.trim()) || gridSave_firstError(answer)
    return { ok: false, rows: null, text: `Save failed: ${err || 'no rows returned'}`, shown: false, hint: '' }
}

// несохранённые ленивые гриды виджета: states — WIDGET._gridSave { binding: { base, saveMethod, keyField } }, getRows(binding) — текущие строки
export function gridSave_dirtyList(states, getRows, opts = {}) {   // IE 2026 10 13 / ODOO-5800
    const out = []
    if (!states || typeof states !== 'object' || typeof getRows !== 'function') return out
    for (const binding of Object.keys(states)) {
        const st = states[binding]
        if (!st || !st.saveMethod || !st.base) continue
        let rows
        try { rows = getRows(binding) } catch (e) { rows = null }
        const d = gridSave_diff(rows, st.base, { raw: opts.raw, keyField: st.keyField })
        if (d.count) out.push({ binding, count: d.count })
    }
    return out
}

// IE 2026 10 13 / ODOO-5800 (бот prod ie-dm-app7 ev21: у грида «Responsibles» несохранённая правка, кнопка панели «Confirm» (responsible_register_confirm) ответила тостом
// и updateDoc со свежими строками (_rows_answer: updates [{binding: 'record._doc.responsible_register', value: rows}]) — set_value заменил массив, load_data → gridSave_baselineIfNew
// принял новый массив за новую загрузку: снимок пересобран, полоса Save погасла ВМЕСТЕ с правкой, молча). Охрана — флаг fe.ux.gridSaveGuard (дефолт ВКЛ; выкл — как было):
//   1) пока у виджета есть несохранённые строки ленивого грида, команды панели (executeWidgetMethod) не выполняются — тост «Save or discard the changes first»;
//   2) строки пришли другим путём (опрос, каскад, ответ чужого метода) — правки возвращаются поверх свежих строк (gridSave_reapply), полоса остаётся.
export const GRID_SAVE_GUARD_FLAG = 'fe.ux.gridSaveGuard'   // IE 2026 10 13 / ODOO-5800

export function gridSaveGuard_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(GRID_SAVE_GUARD_FLAG, true) !== false : true } catch (e) { return true }
}

// методы, которые охрана пропускает: select / reload (у них свой диалог несохранённого), фоновые и справочные (форма настроек, опрос каскада, лог, печать)
const GUARD_PASS_METHODS = new Set(['select', 'reload', 'settings_form', 'cascade_state_refresh', 'cascade_node_refresh', 'select_log', 'get_print'])

// блокировать ли команду: action — действие executeStoreMethod, dirty — [{ binding, count }] (store.gridSave_dirty). { block, reason }
export function gridSave_guardVerdict(action, dirty, flagOn = true) {   // IE 2026 10 13 / ODOO-5800
    const pass = { block: false, reason: '' }
    if (flagOn === false || !Array.isArray(dirty) || !dirty.length) return pass
    const a = action && typeof action === 'object' ? action : {}
    if (a.command !== 'executeWidgetMethod') return pass
    if (a._isPoll || a._gridSave || a._unsaved_ok || a.no_notification) return pass   // опрос, Save самой полосы, команда после диалога, тихий фон
    const m = typeof a.method === 'string' ? a.method : ''
    if (!m || GUARD_PASS_METHODS.has(m)) return pass
    const b = typeof a.binding === 'string' ? a.binding : ''
    if (b.startsWith('_doc.') && !dirty.some((x) => x && x.binding === b)) return pass   // загрузка ДРУГОЙ ленивой вкладки: свои строки не трогает
    return { block: true, reason: 'dirty' }
}

// Правки поверх свежих строк. oldRows — строки грида на момент правок, oldBase — их снимок, fresh — свежие строки (МЕНЯЮТСЯ на месте).
// changed — поля, изменённые против снимка, переносятся в строку с тем же ключом (нет такой — правка теряется, dropped++); added — дописываются; deleted — убираются по ключу.
// Новый снимок — свежих строк ДО правок: разница с ним и есть возвращённые правки. -> { applied, base, count, dropped }
export function gridSave_reapply(oldRows, oldBase, fresh, opts = {}) {   // IE 2026 10 13 / ODOO-5800
    const raw = typeof opts.raw === 'function' ? opts.raw : _ident
    const keyField = opts.keyField || 'id'
    const none = { applied: false, base: null, count: 0, dropped: 0 }
    if (!Array.isArray(fresh) || !oldBase) return none
    const d = gridSave_diff(oldRows, oldBase, { raw, keyField })
    if (!d.count) return none
    const newBase = gridSave_baseline(raw(fresh), raw)
    const objIdx = new Map()
    ;(oldBase.objs || []).forEach((o, i) => { if (o && typeof o === 'object' && !objIdx.has(o)) objIdx.set(o, i) })
    const byKey = new Map()
    for (const r of fresh) { const k = gridSave_key(r, keyField); if (k !== null) byKey.set(String(k), r) }
    let dropped = 0
    for (const row of d.changed) {
        const k = gridSave_key(row, keyField)
        const target = k !== null ? byKey.get(String(k)) : undefined
        const i = objIdx.get(raw(row))
        if (!target || i === undefined) { dropped++; continue }
        let was = {}
        try { was = JSON.parse(oldBase.json[i]) } catch (e) { was = {} }
        const now = gridSave_clean(row)
        for (const f of Object.keys(now)) { if (JSON.stringify(now[f]) !== JSON.stringify(was[f])) target[f] = row[f] }
        for (const f of Object.keys(was)) { if (!(f in now)) delete target[f] }
        target._meta = Object.assign(target._meta && typeof target._meta === 'object' ? target._meta : {}, { modified: true })
    }
    for (const row of d.added) fresh.push(row)
    for (const k of d.deleted) {
        if (k !== null && typeof k === 'object') { dropped++; continue }   // строка без ключа — по ключу не найти
        const i = fresh.findIndex((r) => { const rk = gridSave_key(r, keyField); return rk !== null && String(rk) === String(k) })
        if (i >= 0) fresh.splice(i, 1)
    }
    return { applied: true, base: newBase, count: d.count - dropped, dropped }
}
